import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { NbDialogRef, NbDialogService, NbToastrService } from "@nebular/theme";
import { CommonDialogComponent, NrkDialogType } from "../../../shared/common-dialog/common-dialog.component";
import { LineItemModel, BoxDetails } from "../../../../../@models/erp/lineItem";
import { ApiService } from "../../../../../@core/service/api.service";
import { BoxStatus, EBoxStatus, SpoBoxModel } from "../../../../../@models/erp/spoBox";
import { CompilationModel } from "../../../../../@models/erp/compilation";
import { EventService } from "../../../../../@core/service/eventService";
import { SharedDataService } from "../../../../../@core/service/shared-data.service";
import { sanitizeDateToString } from "../../../../../@core/common/global";
import { error } from "console";
import { init } from "echarts";

@Component({
    selector: 'ngx-box-details',
    templateUrl: './box-details.component.html',
    styleUrls: ['./box-details.component.scss']
  })
  export class BoxDetailsComponent implements OnInit, OnDestroy {
  
    @Input() compilation: CompilationModel;
    @Input() disabled = true;
    @Input() lineItem: LineItemModel;

    spoBoxes: SpoBoxModel[] = [];
    storedSpoBoxes: SpoBoxModel[] = [];
    boxStatus = BoxStatus;
    boxType = null;
    boxTypeOptions = [];

    show = false;
    subscriptions = [];

    editLine = null;

    toastr = inject(NbToastrService);
    dlg = inject(NbDialogService);

    constructor(private api: ApiService, private event: EventService, private data: SharedDataService) { }

    async ngOnInit(): Promise<void> {

        this.subscriptions.push(this.event.preSaveCompilation.subscribe(async newCompilation => {
            console.log('box-details preSaveCompilation', newCompilation.lineItems.findIndex(f => f.code === this.lineItem.code), this.lineItem);
            await this.commitBoxes(newCompilation);
        }))
        this.init();
    }

    async init() {
        // this.data.boxesAreLoading.push(true);
        this.data.boxesAreLoading(true);
        if (!this.lineItem.boxDetails?.length) this.lineItem.boxDetails = [];
        this.storedSpoBoxes = await this.api.loadSpoBoxes({ spo: this.compilation.code, spoPos: this.lineItem.position?.internalPos });
        this.boxType = this.storedSpoBoxes?.[0]?.boxType;
        this.updateSummary();
        this.boxTypeOptions = this.data.cartonBoxOptions;
        // this.data.boxesAreLoading.pop();
        this.data.boxesAreLoading();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    
    save(): void {
        this.dlg.open(CommonDialogComponent, {
            closeOnBackdropClick: true,
            context: {
                dialogType: NrkDialogType.plain,
                message: 'Do not forget to save the document'
            }
        }).onClose.subscribe(() => {
            this.commitBoxes(this.compilation);
        })
        
    }
  
    addItem() {

        if (!this.boxType) {
            this.toastr.danger('Boxes cannot be added without box type', 'Please define box type first');
            return;
        }

        const box = new BoxDetails();
        box.boxType = this.boxType;
        this.lineItem.boxDetails.push(box);
        this.updateSummary()
    }

    async removeItem(item) {

        this.lineItem.boxDetails = this.lineItem.boxDetails?.filter(f => f !== item);
        // if (item.boxId > 0) await this.api.deleteSpoBoxesWithFilter({ boxId: item.boxId });
        this.updateSummary();
    }

    removeAll() {
        this.lineItem.boxDetails = [];
        this.spoBoxes = null;
    }


    getBoxQuantity() {
        return this.spoBoxes.reduce((a, c) => a + (c?.quantity || 0), 0)
    }

    updateSummary() {

        if (!this.lineItem.boxDetails?.length) {
            this.spoBoxes = null;
            return;
        }

        // console.log(this.lineItem.boxDetails);

        const grp: { [key: string]: SpoBoxModel } = {};
        this.lineItem.boxDetails.forEach(el => {
            const fp = this.lineItem.finishedProduct;
            const weight = fp?.content.energy?.rollLength * fp?.content.energy?.width/1000 * fp?.product?.weight/1000;
            if (!grp[el.case]) grp[el.case] = {
                spo: this.compilation.code,
                spoPos: this.lineItem.position.internalPos,
                spoProduct: fp.code,
                case: el.case,
                // tc: [],
                boxType: el.boxType,
                status: EBoxStatus.free,
                weight: 0,
                quantity: 0,
                lot: undefined,
                prodDate: undefined,
                tc: [], 
                tcDate: undefined,
                dnStatus: undefined,
            }
            grp[el.case].quantity += (+el.quantity);
            // use weight from finished-product first; if it does not exist use weight from box-details 
            grp[el.case].weight += (+el.quantity) * (weight || el.netWeight);
            // if (el.grossWeight) grp[el.case].grossWeightOverride = el.grossWeight;
            //if (!grp[el.case].tc.find(tc => el.tc.includes(tc))) grp[el.case].tc.push(...el.tc);
            el.tc?.split(',').map(m => m.trim()).forEach(tc => {
                if (!grp[el.case].tc.includes(tc)) grp[el.case].tc.push(tc);
            })
            // console.log('box updateSummary', el.case, weight, fp, fp?.product, fp?.content?.energy, grp, el.grossWeight, el.netWeight)
        })

        // this.storedSpoBoxes.forEach(box => {
        //     const idx = newBoxes.findIndex(f => f.case === box.case);
        //     if (idx >= 0) this.spoBoxes[idx] = box;
        // });

        this.spoBoxes = Object.values(grp);
        this.spoBoxes.forEach((_box, idx) => {
            const box = this.storedSpoBoxes.find(f => f.case === _box.case)
            if (box) {
                // this.spoBoxes[idx].boxId = box.boxId;
                box.boxType = this.spoBoxes[idx].boxType;
                box.tc = this.spoBoxes[idx].tc;
                box.quantity  = this.spoBoxes[idx].quantity;
                box.weight = this.spoBoxes[idx].weight;
                // box.grossWeightOverride = this.spoBoxes[idx].grossWeightOverride;
                box.spo = this.spoBoxes[idx].spo;
                box.spoPos = this.spoBoxes[idx].spoPos;
                box.spoProduct = this.spoBoxes[idx].spoProduct;
                this.spoBoxes[idx] = box;
            }
        })
        // console.log('create boxes', this.spoBoxes);
        this.updateBoxDetails();

        return this.spoBoxes
    }

    // selected: boolean;
    // boxId: number;
    // case: string;
    // obic: string;
    // article: string;
    // dimension: string;
    // lot: string;
    // quantity: number;
    // tc: string
    // tcDate: Date;
    // boxName: string;
    // lwh: string;
    // grossWeight: number;
    // netWeight: number;
    // prodDate: Date;
    // expiryDate: Date;
    // joints: string;
    // boxType: string; // CB1, CB2, ....

    
    onPasteBoxData(event: ClipboardEvent) {

        event.preventDefault();

        this.spoBoxes = [];

        const clipboardData = event.clipboardData;
        const pastedText = clipboardData.getData('text');
    
        // console.log('pasted data', pastedText);

        let currentCase;
        let currentObic;
        let currentArticle;
        let currentDimension;
        let currentLot;
        let currentQuantity;
        let currentTC;
        let currentTcDate;
        let currentBoxName;
        let currentLwh;
        let currentGrossWeight;
        let currentNetWeight;
        let currentProdDate;
        let currentExpiryDate;
        let currentJoints;
        let currentBoxType;

        // pastedText.split(/[\n\r]+/).forEach(async line => {
        this.splitRespectingQuotes(pastedText).forEach(async line => {
            console.log(`>>${line}<<`)
            const items = line.split(/\t/);
            console.log('split items', items);
            if (items[0] && +items[0] > 0) {
                if (items[0]) currentCase = items[0];
                if (items[1]) currentObic = items[1];
                if (items[2]) currentArticle = items[2];
                if (items[3]) currentDimension = items[3];
                if (items[4]) currentLot = items[4];
                if (items[5]) currentQuantity = +items[5];
                if (items[6]) currentTC = items[6];
                if (items[7]) currentTcDate = sanitizeDateToString(items[7]);
                if (items[8]) currentBoxName = items[8];
                if (items[9]) currentLwh = items[9];
                if (items[10]) currentGrossWeight = +(items[10]?.replace(/,/, '.'));
                if (items[11]) currentNetWeight = +(items[11]?.replace(/,/, '.'));
                if (items[12]) currentProdDate = sanitizeDateToString(items[12]);
                if (items[13]) currentExpiryDate = sanitizeDateToString(items[13]);
                if (items[14]) currentJoints = items[14];
                currentBoxType = this.boxType;

                const existing = this.lineItem.boxDetails.find(f => f.case === currentCase && f.lot === currentLot);
    
                if (existing) {
                    existing.prodDate = currentProdDate;
                    existing.tc = currentTC;
                    existing.tcDate = currentTcDate;
                    existing.boxType = this.boxType;
                    existing.quantity += currentQuantity;
                    existing.grossWeight += currentGrossWeight;
                    existing.netWeight += currentNetWeight;
                    existing.joints = currentJoints;
                } else {
                    this.lineItem.boxDetails.push({
                        boxId: 0,
                        case: currentCase,
                        obic: currentObic,
                        article: currentArticle,
                        dimension: currentDimension,
                        lot: currentLot,
                        quantity: currentQuantity,
                        tc: currentTC,
                        tcDate: currentTcDate,
                        boxName: currentBoxName,
                        lwh: currentLwh,
                        grossWeight: currentGrossWeight,
                        netWeight: currentNetWeight,
                        prodDate: currentProdDate,
                        expiryDate: currentExpiryDate,
                        joints: currentJoints,
                        boxType: currentBoxType,
                    } as BoxDetails)
                }
            }
            // if (items[6] && +items[6] > 0) {
            //     if (items[0]) currentCase = items[0];
            //     if (items[1]) currentLot = items[1];
            //     if (items[2]) currentProdDate = items[2];
            //     if (items[3]) currentTC = items[3];
            //     if (items[4]) currentTcDate = items[4];
            //     currentBoxType = this.boxType;
            //     if (items[6]) currentQuantity = +items[6];
            //     if (items[7]) currentJoints = items[7];

            //     const existing = this.lineItem.boxDetails.find(f => f.case === currentCase && f.lot === currentLot);
    
            //     if (existing) {
            //         existing.prodDate = currentProdDate;
            //         existing.tc = currentTC;
            //         existing.tcDate = currentTcDate;
            //         existing.boxType = this.boxType;
            //         existing.quantity += currentQuantity;
            //         existing.joints = currentJoints;
            //     } else {
            //         this.lineItem.boxDetails.push({
            //             boxId: 0,
            //             case: currentCase,
            //             lot: currentLot,
            //             prodDate: currentProdDate,
            //             tc: currentTC,
            //             tcDate: currentTcDate,
            //             boxType: currentBoxType,
            //             quantity: currentQuantity,
            //             joints: currentJoints,
            //         } as any)
            //     }
            // }

        }) 
        this.updateSummary();
    }

    onClose() {
        console.log('on close', this.spoBoxes, this.storedSpoBoxes)
    }

    async commitBoxes(newCompilation: CompilationModel) {
        const deleteBoxes = [];
        this.storedSpoBoxes.forEach(box => {
            if (!this.spoBoxes.find(f => f.case === box.case)) {
                deleteBoxes.push(box);
            }
        })
        // console.log('delete spo boxes', deleteBoxes);
        await this.api.deleteSpoBoxes(deleteBoxes);


        // const stored = await this.api.loadSpoBoxes({ spo: this.compilation.code })
        // const boxes = this.updateSummary();
        // stored.forEach(el => {
        //     const box = boxes.find(f => f.boxId === el.boxId)
        //     el.boxType = box.boxType;
        //     el.tc = box.tc
        //     el.quantity = box.quantity;
        //     console.log('in commit', el.tc, box.tc);
        // })

        // console.log('commit stored', stored);

        this.editLine = null;

        try {
            this.spoBoxes = await this.api.saveSpoBoxes(this.spoBoxes);
            console.log('commit boxes', this.spoBoxes, deleteBoxes);
            // this.updateBoxDetails(true); 
            this.init();   
        } catch (e) {
            let msg = e?.error?.message;
            if (e?.error?.keyValue?.spo && e?.error?.keyValue?.case) {
                msg = 'box already exists in database';
            }
            this.toastr.danger(msg + '\n' + JSON.stringify(e.error), 'saving boxes failed');
            console.error('commit boxes', e);
        }

    }

    updateBoxDetails(storeBoxDetails = false) {

        // console.log('updateBoxDetails, box details line', storeBoxDetails, this.lineItem.boxDetails);

        let currentTcDate: Date = null;
        let currentProdDate: Date = null;

        this.lineItem.boxDetails.forEach((el, idx) => {

            el.boxId = this.spoBoxes.find(f => f.case === el.case)?.boxId;

            if (storeBoxDetails) {
                if (el.tcDate) {
                    currentTcDate = sanitizeDateToString(el.tcDate);
                } else if (currentTcDate) {
                    el.tcDate = currentTcDate;
                }
    
                if (el.prodDate) {
                    currentProdDate = sanitizeDateToString(el.prodDate);
                } else if (currentProdDate) {
                    el.prodDate = currentProdDate;
                }
                // console.log('box details line', el.boxId, el.tcDate, el.prodDate, currentTcDate, currentProdDate);
            }
        })

        // if (storeBoxDetails) {
        //     const doc = await this.api.loadCompilationByCode(this.compilation.code);
        //     const li = doc.lineItems?.find(f => f.position.internalPos === this.lineItem.position.internalPos);
        //     if (li) li.boxDetails = this.lineItem?.boxDetails;
        //     console.log('updateBoxDetails', this.lineItem.boxDetails, doc.lineItems);
        //     this.api.saveCompilation(doc);
        // }
    }

    boxTypeChanged(boxtype: string) {

        this.boxType = boxtype;
        this.lineItem.boxDetails.forEach(el => {
            el.boxType = boxtype;
            const box = this.spoBoxes.find(f => f.boxId === el.boxId);
            if (box) box.boxType = boxtype;
        })
        this.api.saveSpoBoxes(this.spoBoxes);
    }


    splitRespectingQuotes(text: string): string[] {
        const lines: string[] = [];
        let currentLine = '';
        let inQuotes = false;

        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const nextChar = text[i + 1];

            if (char === '"') {
                // Toggle quote state unless it's an escaped quote ("")
                if (nextChar === '"') {
                    currentLine += '"';
                    i++; // skip the escaped quote
                } else {
                    inQuotes = !inQuotes;
                    // Don't include the quote itself
                }
            } else if ((char === '\n' || char === '\r') && !inQuotes) {
                if (char === '\r' && nextChar === '\n') i++; // Handle \r\n
                lines.push(currentLine.trim());
                currentLine = '';
            } else {
                currentLine += char;
            }
        }

        if (currentLine.length > 0) {
            lines.push(currentLine.trim());
        }

        // Optionally remove surrounding quotes from lines
        return lines.map(line =>
            line.startsWith('"') && line.endsWith('"') ? line.slice(1, -1) : line
        );
    }
    
}
  